import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';

export function SaleListItemInfo(props: any) {
  const sale = props.sale;

  const isPc = useContext(cmnContext).isPc;
  const instList = useContext(SaleListContext).instList;
  // 講師タップで検索
  const setSearchWord = useContext(SaleListContext).setSearchWord;
  const setDetailSale = useContext(SaleListContext).setDetailSale;

  const [inst, setInst] = useState(null);
  const [instName, setInstName] = useState<string>('');
  const defaultImg = '/images/page/lesson/live/noimage_female.png';
  const [instImg, setInstImg] = useState<string>(defaultImg);
  const [createdAt, setCreatedAt] = useState<string>('');


  useEffect(() => {
    // 講師情報
    if (sale?.instructor_id && Array.isArray(instList)) {
      const instructor = instList.find(inst => inst.id === sale.instructor_id);
      if (instructor) {
        setInst(instructor);
        setInstName(instructor.name);
        // 講師画像
        let instImgFile = (instructor.image_file);
        if(instImgFile) {
          // 設定済み
          setInstImg(`/images/instructor/${instImgFile}?202510`);
        } else if(instructor.gender == '1') {
          // 設定なし：男性
          setInstImg('/images/page/lesson/live/noimage_male.png');
        } else {
          // 設定なし：女性
          setInstImg(defaultImg);
        }
      }
    }

    // 作成日
    if(sale?.created_at) {
      try {
        const date = new Date(sale.created_at);
        const formatted = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
        setCreatedAt(formatted);
      } catch(err) {
        setCreatedAt('');
      }
    }
  }, [sale, instList])


  // 講師タップで検索
  const onPressInst = () => {
    if(inst && instName) {
      setSearchWord(instName);
      setTimeout(() => {
        // 詳細モーダルを再生しない
        setDetailSale(null);
      }, 10)
    }
  }


  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      gap: '5px',
      marginTop: 10,
    }}>

      {/* 講師画像 */}
      {inst &&
        <div
          style={{flex: 1}}
          onClick={onPressInst}
        >
          <img
            src={instImg}
            onError={(e) => {
              const target = e.currentTarget;
              target.onerror = null; // 無限ループ防止
              target.src = defaultImg;
            }}
            style={{
              width: '100%',
              aspectRatio: '1 / 1',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        </div>
      }

      {/* 情報 */}
      <div style={{flex: isPc? 7 : 6}}>
        {/* 動画タイトル：２行まで */}
        <p style={{
          fontWeight: 'bold',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          margin: '0px 0px 5px 0px',
        }}>{sale.name}</p>

        {/* 講師名 */}
        {instName &&
          <p
            style={{
              fontSize: isPc? '90%' : '95%',
              margin: 0
            }}
            onClick={onPressInst}
          >
            動画出演の講師: {instName}
          </p>
        }

        {/* 作成日 */}
        {createdAt &&
          <p style={{
            fontSize: isPc? '90%' : '95%',
            margin: 0
          }}>{createdAt}</p>
        }
      </div>

    </div>
  );
}